import React from 'react';

const ProfileMainSection = ({ children }) => {
  return (
    <div className="flex-1 w-full bg-white p-5 md:p-8 rounded-3xl shadow-sm border border-slate-100 min-h-[500px]">
      {children}
    </div>
  );
};

export default ProfileMainSection;